module.exports = __webpack_public_path__ + "img/headchoose.f4b502c6.svg";